import React, { useEffect } from "react"
import Layout from "~/components/Layout";
import { useLang } from "~/hooks/useLang";
import AuditUserActionsReportTable from "../components/UserActionsReport";

export default function AuditUserActionsReport() {
    const { translate } = useLang();

    useEffect(() => {
        document.title = translate('User Actions report Audit - Dispatch System')
    }, [])
    return (
        <Layout marginLayout={true}>
            <AuditUserActionsReportTable />
        </Layout>
    )
}